import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";

const DOCS = [
  { to: "/privacy-policy", title: "Privacy Policy", desc: "What we collect, why, and how it's protected." },
  { to: "/terms-and-conditions", title: "Terms & Conditions", desc: "The full service terms — 35 sections, plainly written." },
  { to: "/refund-policy", title: "Refund Policy", desc: "How prepaid engagements and refunds are handled." },
  { to: "/cookie-policy", title: "Cookie Policy", desc: "The cookies and local storage we use." },
];

const HANDOVER = ["Source code", "Application credentials", "Deployment credentials", "Project assets", "Relevant documentation"];

export default function Legal() {
  return (
    <div className="pt-32 lg:pt-40 pb-24" data-testid="legal-page">
      <div className="container-x max-w-4xl">
        <p className="section-label">LEGAL</p>
        <h1 className="mt-5 font-heading text-5xl sm:text-6xl font-black tracking-tight text-white">
          TERMS, <span className="text-flame">PLAINLY.</span>
        </h1>
        <p className="mt-6 text-xs text-slate-500 max-w-2xl leading-relaxed border border-white/10 rounded-lg p-4 bg-navy-800">
          These documents are working drafts provided for transparency. They should be reviewed by qualified legal
          counsel before production launch. The signed project agreement governs each engagement.
        </p>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {DOCS.map((d) => (
            <Link key={d.to} to={d.to} data-testid={`legal-doc-${d.to.slice(1)}`} className="rounded-2xl border border-white/10 bg-navy-800 p-8 card-lift group block">
              <div className="flex items-start justify-between">
                <h2 className="font-heading text-xl font-bold text-white">{d.title}</h2>
                <ArrowUpRight className="w-5 h-5 text-slate-600 group-hover:text-flame transition-colors" />
              </div>
              <p className="mt-3 text-sm text-slate-400">{d.desc}</p>
            </Link>
          ))}
        </div>

        <section id="ownership" className="mt-16 scroll-mt-28 rounded-2xl border border-flame/30 bg-navy-800 p-8 sm:p-12" data-testid="legal-ownership">
          <p className="section-label">SOURCE CODE / IP TERMS</p>
          <h2 className="mt-4 font-heading text-3xl font-bold text-white">YOUR SOFTWARE. YOUR CODE.</h2>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-2xl">
            Subject to the applicable project agreement and full payment, the client will receive the source code and
            relevant project assets agreed as part of the engagement. Third-party libraries, APIs, SaaS products and
            open-source components remain subject to their respective licenses.
          </p>
          <ul className="mt-8 space-y-4">
            {HANDOVER.map((i) => (
              <li key={i} className="flex items-center gap-4">
                <span className="w-8 h-8 rounded-full bg-flame/15 border border-flame/40 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-flame" />
                </span>
                <span className="font-heading font-semibold text-slate-100">{i}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="mt-10 rounded-2xl border border-white/10 bg-navy-800 p-8 sm:p-12">
          <p className="section-label">DISCLAIMER</p>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Delivery figures shown on this website (approximately 3–5 hour Rush Hour sessions, approximately 7-day
            standard delivery, approximately 50-hour project targets) are illustrative targets for suitable projects —
            not guarantees. Many suitable applications can be completed within estimated development hours; final pricing
            and timeline are confirmed after requirement analysis. We do not guarantee business results, application
            performance or scalability outcomes. Foreign-currency prices are converted from base INR pricing using
            current or recently retrieved exchange rates.
          </p>
        </section>
      </div>
    </div>
  );
}
